"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var FoodInStockSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M9,15 L2,15 L2,14 L3,14 L3,11.5 C3,8.63097872 5.19674999,6.2750359 8,6.02242151 L8,5 L7,5 L7,4 L10,4 L10,5 L9,5 L9,6.02242151 C10.9259084,6.19597441 12.5655451,7.3623111 13.4032224,9.00574387 C12.9509094,9 13,9 12.2476745,9.00815958 C11.4411594,7.79759702 10.0637241,7 8.5,7 C6.01471863,7 4,9.01471863 4,11.5 C4,11.6126697 4.00168096,12.446003 4.00504288,14 L9,14 L9,15 Z M15.1464466,11.1464466 C15.3417088,10.9511845 15.6582912,10.9511845 15.8535534,11.1464466 C16.0488155,11.3417088 16.0488155,11.6582912 15.8535534,11.8535534 L12.5,15.2071068 L11.1464466,13.8535534 C10.9511845,13.6582912 10.9511845,13.3417088 11.1464466,13.1464466 C11.3417088,12.9511845 11.6582912,12.9511845 11.8535534,13.1464466 L12.5,13.7928932 L15.1464466,11.1464466 Z" })));
};
FoodInStockSmall.displayName = 'FoodInStockSmall';
exports.default = FoodInStockSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=FoodInStockSmall.js.map